module.exports = __webpack_public_path__ + "img/searchGlass.28a80221.svg";